import React, { useState } from 'react';
import { ProgramCard } from './program-card.jsx';
import { EligibilityPanel } from './eligibility-panel.jsx';

function getInitials(name) {
  return (name || '').split(' ').map(s => s[0]).slice(0, 2).join('').toUpperCase();
}

// props:
//   patient, dx (string[]), cards (array of { model, onGenerate, onPush, onRedirect, onHistory }),
//   onBack, onOverrides, onViewEmr, onClose, onEligibilityRefreshed,
//   mode: 'rail' | 'band', expanded (band only), onToggleExpanded (band only)
export function StatusRail(props) {
  const {
    patient, dx = [], cards = [], onBack, onOverrides, onViewEmr, onClose,
    onEligibilityRefreshed, mode = 'rail', expanded = false, onToggleExpanded,
  } = props;
  const [dxOpen, setDxOpen] = useState(false);
  if (!patient) return null;

  const shownDx = dxOpen ? dx : dx.slice(0, 2);
  const extra = dx.length - shownDx.length;

  // Collapsed iPad band: name + status chips only.
  if (mode === 'band' && !expanded) {
    return (
      <div className="status-band status-band-collapsed">
        <button className="status-band-back" onClick={onBack} aria-label="Back to roster">‹</button>
        <b className="status-band-name">{patient.name}</b>
        <span className="status-band-chips">
          {cards.map((c) => (
            <span key={c.model.program} className={`elig-chip ${c.model.statusChip ? c.model.statusChip.tone : 'ok'}`}>
              {c.model.program === 'bhi' ? 'BHI' : 'CCM'}{c.model.statusChip ? ` ${c.model.statusChip.label}` : ''}
            </span>
          ))}
        </span>
        <button className="status-band-toggle" onClick={onToggleExpanded} aria-label="Expand">▾</button>
      </div>
    );
  }

  const wrapClass = mode === 'band' ? 'status-rail status-rail-band' : 'status-rail';

  return (
    <div className={wrapClass}>
      <div className="status-rail-identity">
        {onBack && <button className="rail-back link-btn" onClick={onBack}>‹ Roster</button>}
        {mode === 'band' && (
          <button className="status-band-toggle" onClick={onToggleExpanded} aria-label="Collapse">▴</button>
        )}
        <div className="rail-name-row">
          <div className={`avatar av-${patient.avSlot}`}>{getInitials(patient.name)}</div>
          <div className="rail-name-copy">
            <h2 className="rail-name">{patient.name}</h2>
            <div className="rail-meta">
              {(patient.age != null || patient.sex) && (
                <span>{patient.age != null ? patient.age : ''}{patient.sex}</span>
              )}
              {patient.mrn && (
                <><span className="sep">·</span><span className="mono">{patient.mrn}</span></>
              )}
            </div>
          </div>
        </div>
        <div className="rail-actions">
          <button className="btn sm" onClick={onOverrides}>⚙ Overrides</button>
          <button
            className="btn sm"
            disabled={!patient._raw?.elation_id}
            onClick={onViewEmr}>
            EMR ↗
          </button>
          {onClose && (
            <button className="btn ghost sm" onClick={onClose} aria-label="Close">✕</button>
          )}
        </div>
        {dx.length > 0 && (
          <div className="rail-dx">
            {shownDx.map((d, i) => (
              <span key={i} className="rail-dx-chip" title={d}>{d}</span>
            ))}
            {extra > 0 && (
              <button
                className="rail-dx-chip rail-dx-more"
                onClick={() => setDxOpen(true)}>
                +{extra} dx ▾
              </button>
            )}
            {dxOpen && (
              <button
                className="rail-dx-chip rail-dx-more"
                onClick={() => setDxOpen(false)}>
                less ▴
              </button>
            )}
          </div>
        )}
      </div>

      <div className="status-rail-cards">
        {cards.map((c) => (
          <ProgramCard
            key={c.model.program}
            model={c.model}
            onGenerate={c.onGenerate}
            onPush={c.onPush}
            onRedirect={c.onRedirect}
            onHistory={c.onHistory}
          />
        ))}
      </div>

      <div className="status-rail-eligibility">
        <EligibilityPanel patient={patient} onRefreshed={onEligibilityRefreshed} />
      </div>
    </div>
  );
}
